import React, { useMemo, useState, memo } from 'react';
import { createEditor, Transforms, Text, Editor, BaseEditor, NodeEntry, Descendant } from 'slate';
import { Slate, Editable, withReact, RenderLeafProps, ReactEditor } from 'slate-react';
import { R } from '@core/utils/r';

const REGEX = /{{(.*?)}}/g;

const Leaf = ({ attributes, children, leaf }: RenderLeafProps) => (
  <span style={R.get(leaf, 'variable') ? { color: 'white', backgroundColor: '#07456B', padding: 2, borderRadius: 4 } : {}} {...attributes}>
    {children}
  </span>
);

const decorate = ([node, path]: NodeEntry) => {
  if (!Text.isText(node)) return [];

  const ranges = [];
  let match = null;

  while ((match = REGEX.exec(node.text)) !== null) {
    ranges.push({
      variable: true,
      anchor: { path, offset: match.index },
      focus: { path, offset: match.index + match[0].length },
    });
  }

  return ranges;
};

const withSingleLine = (editor: BaseEditor & ReactEditor) => {
  const { normalizeNode } = editor;

  editor.normalizeNode = ([node, path]) => {
    if (path.length === 0) {
      if (editor.children.length > 1) {
        Transforms.mergeNodes(editor);
      }
    }

    return normalizeNode([node, path]);
  };

  return editor;
};

export const HighlightedInput = memo(() => {
  //   const editor: Editor = useMemo(() => withSingleLine(withReact(createEditor())), []);
  const editor = useMemo(() => withSingleLine(withReact(createEditor())), []);
  const [value, setValue] = useState<any[]>([
    {
      type: 'paragraph',
      children: [{ text: 'Test input' }],
    },
  ]);

  return (
    <Slate editor={editor} value={value} onChange={setValue}>
      <Editable
        decorate={decorate}
        renderLeaf={Leaf}
        className="form-control"
        style={{
          whiteSpace: 'pre',
        }}
      />
    </Slate>
  );
});
